<template>
    <div id="app">
      <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {}
    }
</script>

<style lang="scss">
body {
  font-family: 'Montserrat', sans-serif !important;
}

.m-auto {
  margin: auto;
}

.is-blue {
  background-color: #3585C8 !important;
}

.is-size-8 {
  font-size: .65rem !important;
}

.enneagram {
  .button {
    color: #4a4a4a !important;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12),0 3px 1px -2px rgba(0,0,0,.2);
  }

  .button.is-blue {
    background-color: #85becc !important;
  }
}
</style>